import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { Button,Input,Table,TableColumn } from 'element-ui';
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});